
import { Component, Vue } from 'vue-property-decorator';

import Form1ProcessHeader from "@/components/process/Form1/components/Form1ProcessHeader.vue";
import Form1 from "@/components/process/Form1/components/pdf/Form1.vue"
import { form1StatusInfoType } from '@/types/Information/Form1';

@Component({
    components:{
        Form1ProcessHeader,
        Form1
    }
})
export default class PreviewForm1 extends Vue {

    stepsCompleted = {} as form1StatusInfoType; 
    
    dataReady = false;
    pdfReady = false;

    mounted() {
        this.dataReady = false;
        this.stepsCompleted = {
            first: true,
            second: true,
            third: false,
            fourth: false
        }
        this.dataReady = true;       
    }

    public navigateToSubmitPage() {
        this.$router.push({name: "proceed-form1"}); 
    }
}
